import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import ContactInfo from './ContactComponent';

import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  footer: {
    color: 'white',
    padding: theme.spacing(6),
    backgroundColor: '#2C2C2C',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(4),
    },
  },
  sectionHeader: {
    marginBottom: '0.2rem',
  },
  text: {
    marginTop: '0.2rem',
  },
  link: {
    color: 'white',
  },
  typo: {
    marginTop: '1rem',
  },
}));

const Copyright = () => {
  return (
    <Typography variant="body2" align="center">
      {'Copyright © '}
      <Link style={{ color: 'white' }} to="/">
        Группа компаний «Стройпром»
      </Link>

      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};

const Footer = () => {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h5" color="inherit">
            Навигация
          </Typography>
          <Typography className={classes.typo} variant="body1" color="inherit">
            <Link className={classes.link} to="/">
              Главная
            </Link>
          </Typography>
          <Typography className={classes.typo} variant="body1" color="inherit">
            <Link className={classes.link} to="/product">
              Продукт
            </Link>
          </Typography>
          <Typography className={classes.typo} variant="body1" color="inherit">
            <Link className={classes.link} to="/contact">
              Контакты
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h5" color="inherit">
            Контакты
          </Typography>
          <ContactInfo />
        </Grid>
      </Grid>
      <Copyright />
    </footer>
  );
};

export default Footer;
